import DeviceShare from './DeviceShare';
export default DeviceShare;
